<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content"><b><i>Editor’s Dedication</i></b></p>
<p class="subsq dedication-content">To Kevin J. Anderson, Allyson Longueira, Gwyneth Gibby, and my cohort colleagues at Western Colorado University GPCW-Publishing, thank you for your support throughout this amazing journey.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0569e7cd